import React, { useState } from "react";
import { useLoader } from "../../utils/LoaderUtils";
import { showError, showSuccess } from "../../utils/toastUtils";
import slugify from "slugify";
import brandAPI from "../../api/brandApi";
import SEOFields from "../../components/partials/SEOFields";
import ImageUploader from "../../components/partials/ImageUploader";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import SubmitButton from "../../components/partials/global/SubmitButton";

function AddNew() {
  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    slug: "",
    navbar: false,
    homepage: false,
    image: "",
  });

  const [seoData, setSeoData] = useState({
    metaTitle: "",
    metaDescription: "",
    tags: [],
  });

  const validate = () => {
    const newErrors = {};

    if (!formData.title.trim()) {
      newErrors.title = "Title field is mandatory";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleImageUploadSuccess = (type, url) => {
    setFormData((prev) => ({
      ...prev,
      [type]: url,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    showLoader();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const payload = {
        ...formData,
        slug: slugify(formData.title, { lower: true }),
        metaTitle: seoData.metaTitle,
        metaDescription: seoData.metaDescription,
        keywords: seoData.tags.join(","),
      };

      const res = await brandAPI.addDetails(payload);

      if (res.code === 200) {
        setFormData({
          title: "",
          description: "",
          slug: "",
          navbar: false,
          homepage: false,
          image: "",
        });

        setSeoData({
          metaTitle: "",
          metaDescription: "",
          tags: [],
        });

        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Add New Brand</h4>
            <h6>
              Create a new brand to showcase product listing on your store.
            </h6>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Add Details</h4>
          </div>

          <div className="card-body profile-body">
            <form method="post" onSubmit={handleSubmit}>
              <ImageUploader
                type="image"
                label="Brand Image"
                value={formData.image}
                onUploadSuccess={handleImageUploadSuccess}
                assetType="brands"
              />

              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Title <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <i className="fa fa-pencil"></i>
                    </span>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      placeholder="Title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.title && (
                    <span className="errors text-danger">{errors.title}</span>
                  )}
                </div>

                <div className="col-lg-3 col-sm-6">
                  <label className="form-label">Show In Navbar</label>

                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="navbar"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={formData.navbar}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheckChecked"
                    >
                      Show
                    </label>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <label className="form-label">Show in Home Page</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="homepage"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={formData.homepage}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheckChecked"
                    >
                      Show
                    </label>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-12">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>

              <hr />

              <SEOFields
                seoData={seoData}
                setSeoData={setSeoData}
                slug={slugify(formData.title || "", { lower: true })}
                errors={errors}
              />

              <div className="row mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <SubmitButton
                    isLoading={isLoading}
                    text="Submit Details"
                    loadingText="Submitting..."
                  ></SubmitButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNew;
